// NOTE: this is a temporary hack to have hard coded value as current webpacker setup doesn't have access to env vars
const globalConfigs = typeof window === 'undefined' ? { clientUrl: 'https://account.artkiveapp.com' } : window.app

// NOTE: on server side rendering we don't have Routing object so have to use this
export default {
  aboutUs: '/about-artkive-keepsake-app',
  artOfMe: 'https://artofme.artkiveapp.com/',
  international: 'https://international.artkivebox.com/',
  books: '/keepsakes/art-book-for-kids',
  boxCheckout: '/box-checkout',
  artReturn: '/customer_invoices/art_return',
  artRecycle: '/customer_invoices/art_recycle',
  artRecycleCancel: '/customer_invoices/art_recycle/cancel',
  artRecycleConfirm: '/customer_invoices/art_recycle/confirm',
  checkout: '/checkout',
  checkoutConfirmation: '/checkout-confirmation',
  contact: '/contact',
  orderTracking: '/order-tracking',
  digital: '/digitization',
  facebook: 'https://www.facebook.com/artkiveapp/',
  faqs: 'https://artkiveboxhelp.zendesk.com/hc/en-us',
  lifekiveFaqs: 'https://faq.lifekive.com',
  giftCards: '/giftcards',
  giftCardConfirmation: '/giftcards-confirmation',
  home: '/',
  instagram: 'https://www.instagram.com/artkivebox/',
  ios: 'https://itunes.apple.com/us/app/artkive-save-kids-art/id549980508?mt=8',
  lifekive: 'https://www.lifekive.com/',
  cardsByArtkive: 'https://www.cards.artkivebox.com/',
  albumsByArtkive: 'https://www.albumsbyartkive.com/',
  photosByArtkive: 'https://www.photosbyartkive.com/',
  photokive: 'https://www.photokive.com/',
  login: globalConfigs.clientUrl,
  accountOrders: `${globalConfigs.clientUrl}/orders`,
  accountDetails: `${globalConfigs.clientUrl}/account`,
  accountPhotos: `${globalConfigs.clientUrl}/photos`,
  plans: '/plans',
  pricing: '/pricing',
  plansCheckout: '/plans/checkout',
  plansConfirmation: '/plans/confirmation',
  mosaics: '/keepsakes/kids-art-frames',
  ourProcess: '/kids-art-display-how-to',
  pinterest: 'https://www.pinterest.com/ARTKIVE/',
  tiktok: 'https://www.tiktok.com/@artkivebox',
  privacy: '/privacypolicy',
  tou: '/tou',
  giftCardCheckout: (type) => `/giftcards/${type}/checkout`,
  twitter: 'https://twitter.com/artkivebox?lang=en',
  youtube: 'https://www.youtube.com/channel/UC2cgBQDf9YFr7AbVceWKG5g',
  nft: 'https://nft.artkivebox.com/',
  blog: 'https://blog.artkiveapp.com/',
  calendly: 'https://calendly.com/artkive',
}
